export class CreateJobTemplateInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        },
        {
            "name": "eonSparkVersions",
            "baseName": "eonSparkVersions",
            "type": "Array<EonSparkVersion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateJobTemplateInput.attributeTypeMap;
    }
    constructor() {
    }
}
